import(/* webpackMode: "eager" */ "/vercel/path0/apps/golden-visa/app/(with-rich-layout)/error.tsx");
